export const initHeader = () => {
    const header = document.querySelector('.header');
    const toggle = document.querySelector('.header__toggle');
    const menuWrapper = document.querySelector('.header__menu-wrapper');
    const toggleLines = document.querySelectorAll('.header__toggle-line');
    const subMenuItems = document.querySelectorAll(
        '.header-menu__item.has-submenu'
    );

    if (toggle && menuWrapper) {
        toggle.addEventListener('click', () =>
            toggleMenu(toggle, menuWrapper, toggleLines)
        );
    }

    if (subMenuItems.length) {
        initSubMenus(subMenuItems);
    }

    // Dodaj nową funkcjonalność sticky header
    if (header) {
        initStickyHeader(header);
    }
};

const toggleMenu = (toggle, menuWrapper, toggleLines) => {
    toggle.classList.toggle('is-active');
    menuWrapper.classList.toggle('-active');
    document.body.classList.toggle('menu-is-active');

    // Aktywacja linii w hamburger menu
    toggleLines.forEach(line => {
        line.classList.toggle('-active');
    });

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isExpanded);
};

const initSubMenus = subMenuItems => {
    subMenuItems.forEach(item => {
        const link = item.querySelector('.header-menu__link');
        const submenu = item.querySelector('.header-menu__submenu');

        if (window.innerWidth < 1200) {
            // Zmiana z 992 (lg) na 1200 (xl)
            link.addEventListener('click', e => {
                e.preventDefault();
                submenu.classList.toggle('-active');
            });
        }
    });
};

// Dodaj nową funkcję
const initStickyHeader = header => {
    let lastScroll = 0;
    const scrollThreshold = 100; // Próg przewijania przed aktywacją sticky

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;

        // Sprawdź czy przewinięto wystarczająco do aktywacji sticky
        if (currentScroll > scrollThreshold) {
            header.classList.add('is-sticky');

            // Określ kierunek przewijania i pokaż/ukryj header
            if (currentScroll > lastScroll) {
                // Przewijanie w dół
                header.classList.add('is-hidden');
            } else {
                // Przewijanie w górę
                header.classList.remove('is-hidden');
            }
        } else {
            // Wróć do pierwotnego stanu
            header.classList.remove('is-sticky', 'is-hidden');
        }

        lastScroll = currentScroll;
    });
};
